import styled from "styled-components";

const SVGWrapper = styled.svg`
  width: 120px;
  @media (max-width: 640px) {
    width: 100px;
  }
`;

const Otoxo_Logo = () => {
  return (
    <SVGWrapper
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800.000000 800.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)"
        fill="#253569"
        stroke="none"
      >
        <path
          d="M3680 7783 c-268 -26 -419 -50 -620 -99 -545 -133 -1040 -379 -1490
-738 -159 -127 -437 -405 -562 -562 -468 -585 -740 -1242 -830 -1999 -17 -144
-17 -644 0 -790 102 -882 463 -1647 1066 -2264 638 -651 1436 -1034 2361
-1132 151 -16 563 -16 715 -1 768 80 1449 360 2050 841 127 102 375 345 491
481 491 579 792 1273 886 2040 24 204 24 659 -1 855 -59 467 -173 856 -366
1250 -258 526 -656 1008 -1125 1361 -572 431 -1243 688 -1970 754 -101 9 -522
11 -605 3z m-1879 -2774 c266 -66 435 -243 499 -524 20 -84 22 -114 17 -228
-7 -146 -26 -226 -77 -331 -38 -77 -125 -185 -183 -227 -63 -46 -179 -99 -239
-109 -29 -4 -66 -13 -81 -19 -67 -26 -246 -2 -395 54 -199 73 -357 303 -393
573 -12 93 2 260 27 321 8 18 14 40 14 48 0 8 19 54 42 101 55 112 169 230
272 282 155 78 336 99 497 59z m2303 -2 c181 -43 342 -172 424 -338 23 -47 42
-92 42 -100 0 -8 8 -34 17 -59 14 -36 17 -80 17 -215 1 -190 -9 -236 -82 -385
-43 -88 -170 -222 -242 -256 -147 -69 -222 -87 -350 -88 -117 0 -217 22 -325
73 -121 58 -218 154 -280 281 -15 30 -31 63 -36 72 -23 45 -49 203 -49 303 0
110 25 255 55 311 8 16 15 34 15 40 0 6 7 17 15 24 8 7 15 25 15 41 l0 28
-182 3 c-123 2 -187 -1 -196 -8 -11 -9 -14 -123 -15 -570 l-2 -559 -150 0
-150 0 -5 565 -5 565 -205 6 c-113 3 -206 7 -208 7 -1 1 -1 57 0 125 l3 122
550 3 c303 1 561 0 574 -3 23 -6 24 -7 19 -101 -4 -65 -1 -99 7 -111 13 -17
35 -10 35 12 0 21 112 117 172 147 86 43 101 48 174 68 85 22 247 21 348 -3z
m2427 2 c207 -51 348 -164 442 -355 55 -110 72 -197 72 -359 -1 -241 -53 -385
-199 -544 -91 -99 -289 -180 -463 -189 -122 -6 -308 47 -412 118 -120 81 -208
207 -263 375 -20 62 -23 89 -23 240 0 190 11 239 83 385 48 100 168 220 266
270 155 78 336 99 497 59z m-1659 -26 c16 -20 117 -182 196 -314 73 -122 72
-122 121 -50 23 33 41 62 41 64 0 3 24 41 53 85 28 44 72 112 95 151 24 38 50
72 59 75 8 3 80 6 159 6 121 0 146 -2 151 -16 3 -8 -3 -25 -15 -37 -29 -32
-412 -605 -412 -617 0 -8 327 -503 465 -705 5 -8 6 -17 3 -21 -4 -4 -83 -6
-175 -5 -161 1 -169 2 -186 24 -36 44 -267 414 -267 427 0 4 -7 10 -15 14 -24
9 -27 6 -235 -323 -98 -155 -72 -140 -245 -141 -82 -1 -156 -1 -162 -1 -19 1
-16 19 8 49 11 15 117 173 235 351 224 340 224 340 184 386 -9 11 -81 117
-160 235 -173 259 -207 309 -230 335 -35 40 -18 45 154 45 143 0 165 -2 178
-17z m-1897 -1873 l0 -154 -79 -2 c-78 -2 -80 -2 -113 31 -28 28 -33 40 -33
80 0 40 5 52 34 81 35 35 81 45 103 23 19 -19 33 0 33 45 0 49 6 58 35 54 19
-3 20 -10 20 -158z m2215 145 c10 -12 10 -18 0 -30 -27 -32 -71 -8 -56 30 3 8
14 15 24 15 11 0 25 -7 32 -15z m-503 -32 c3 -10 15 -29 27 -42 l21 -23 -22
-15 c-19 -13 -23 -25 -23 -66 0 -44 4 -54 27 -73 33 -26 26 -54 -14 -54 -54 0
-75 35 -72 120 1 37 -3 65 -11 75 -10 12 -10 21 -2 38 5 12 13 30 16 40 3 9
15 17 26 17 11 0 23 -8 27 -17z m-3522 -74 c32 -28 35 -36 35 -84 0 -47 -4
-57 -32 -85 -32 -32 -49 -35 -118 -19 -11 3 -16 -7 -18 -44 -3 -50 -22 -71
-45 -48 -14 14 -19 248 -5 274 5 10 20 17 36 17 15 0 34 5 42 10 29 19 69 11
105 -21z m495 16 c10 -12 15 -12 36 1 13 9 31 14 39 10 24 -9 17 -34 -13 -50
-44 -23 -55 -42 -61 -109 -5 -53 -9 -62 -26 -62 -18 0 -20 8 -23 99 -1 55 0
106 2 113 7 17 31 17 46 -2z m656 -19 c29 -29 34 -41 34 -81 0 -40 -5 -52 -34
-81 -28 -28 -42 -34 -76 -34 -110 0 -156 117 -78 197 27 27 39 33 76 33 37 0
50 -6 78 -34z m1124 19 c6 -8 9 -23 5 -35 -12 -36 5 -119 24 -125 44 -14 74
35 70 112 -3 43 5 63 26 63 25 0 30 -26 25 -117 l-5 -88 -45 -8 c-25 -4 -59
-10 -75 -13 -24 -4 -35 0 -55 21 -21 22 -25 38 -28 101 -3 49 0 79 8 89 16 19
34 19 50 0z m750 -13 c36 -30 34 -52 -3 -52 -12 0 -31 7 -41 15 -27 20 -42 19
-66 -7 -24 -26 -25 -50 -4 -83 20 -30 48 -32 71 -5 23 26 63 27 63 1 0 -28
-56 -71 -91 -71 -42 0 -86 25 -104 60 -58 112 78 223 175 142z m1596 -5 c26
-24 37 -43 41 -74 5 -40 3 -46 -35 -83 -32 -32 -47 -40 -76 -40 -80 0 -122 49
-117 139 0 12 16 38 35 57 47 47 101 48 152 1z m624 8 c19 -20 24 -39 28 -103
3 -63 1 -80 -12 -91 -31 -26 -46 -6 -46 64 0 52 -4 69 -20 85 -40 40 -87 -18
-76 -91 7 -42 -12 -76 -38 -66 -14 6 -16 20 -14 104 l3 98 35 3 c19 2 39 8 45
13 18 18 71 10 95 -16z m604 3 c16 -26 0 -33 -45 -19 -32 10 -44 10 -55 0 -19
-16 -8 -27 57 -53 29 -12 57 -28 62 -37 18 -29 -1 -67 -45 -90 -35 -18 -47
-20 -78 -10 -43 13 -73 42 -68 68 6 30 32 25 56 -12 25 -39 56 -46 72 -16 13
24 -10 51 -44 51 -13 0 -33 9 -46 20 -13 11 -27 20 -32 20 -4 0 -8 13 -8 29 0
47 41 73 108 69 39 -2 58 -8 66 -20z m-1829 -8 c9 -14 10 -174 1 -188 -10 -17
-43 -15 -50 4 -8 21 -8 179 1 187 10 10 41 8 48 -3z"
        />
        <path
          d="M1512 4755 c-85 -27 -164 -102 -216 -202 -25 -49 -47 -169 -47 -258
-1 -201 82 -364 221 -437 40 -20 59 -23 165 -23 137 0 175 13 253 88 90 86
122 186 122 376 0 150 -15 217 -67 305 -33 57 -126 133 -180 148 -60 17 -202
19 -251 3z"
        />
        <path
          d="M3804 4755 c-110 -35 -193 -127 -236 -262 -29 -93 -32 -289 -4 -378
39 -126 101 -207 196 -257 40 -20 59 -23 165 -23 108 0 125 3 168 24 59 31
136 111 164 171 77 164 69 420 -17 564 -47 77 -128 142 -201 161 -66 18 -179
18 -235 0z"
        />
        <path
          d="M6242 4755 c-81 -26 -149 -85 -197 -170 -86 -152 -90 -409 -10 -560
34 -65 104 -136 163 -166 42 -21 60 -24 167 -24 137 0 175 13 253 88 89 86
122 187 122 373 0 191 -34 292 -129 381 -73 69 -141 93 -252 92 -41 -1 -93 -7
-117 -14z"
        />
        <path
          d="M2843 3119 c-44 -16 -39 -99 7 -114 13 -4 31 0 45 9 41 27 31 81 -20
108 -5 3 -20 2 -32 -3z"
        />
        <path
          d="M1056 3109 c-14 -11 -26 -31 -26 -43 0 -27 34 -66 59 -66 48 0 70 86
29 114 -29 20 -30 20 -62 -5z"
        />
        <path
          d="M2213 3120 c-48 -19 -38 -103 13 -116 22 -6 32 -2 51 20 29 34 29 51
-2 81 -26 27 -29 28 -62 15z"
        />
        <path
          d="M5676 3109 c-14 -11 -26 -31 -26 -43 0 -28 35 -66 60 -66 25 0 60 38
60 66 0 20 -41 64 -60 64 -4 0 -19 -9 -34 -21z"
        />
      </g>
    </SVGWrapper>
  );
};

export default Otoxo_Logo;
